
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import moment from 'moment';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Link,
  Checkbox,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  DialogContentText,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
  Tooltip,
  TextField,
  Breadcrumbs,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment
} from '@mui/material';
import {
  LocalPrintshop as PrintIcon,
  ArrowBack as BackIcon,
  Payment as PaymentIcon,
  Send as SendIcon,
  Delete as DeleteIcon,
  Link as LinkIcon,
  GetApp as GetDataIcon,
  Add as AddIcon,
  Home as HomeIcon,
  Visibility as ViewIcon,
  Email as EmailIcon,

  Clear as ClearIcon,
} from '@mui/icons-material';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BillingDetailsModal from '../../Ragistration/BConfirmation/ACCGenerateDetailsModal';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { AgGridReact } from 'ag-grid-react';
import { jsPDF } from "jspdf";
import { useReactToPrint } from 'react-to-print';
import { toast, ToastContainer } from 'react-toastify';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axiosInstance from '../../../lib/axios';
import axiosInstanceForPG from '../../../lib/axiosFormPG';
import { useSelector, useDispatch } from 'react-redux';
import PropertyFilter from '../../PropertyFilter';
import {
  selectProperties,
  selectGlobalProperty,
  selectLocalProperty,
  setLocalProperty,
    setGlobalProperty, 
  fetchProperties,
  selectGatewayType
} from '../../../redux/propertySlice';
import logo from '../../../../src/assets/Images/Clanbridge-logo.png2.png';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import {generatePaymentAdvicePDF} from './PaymentAdvicePDF';
// AG Grid Styles
const gridStyles = `
  .ag-theme-alpine {
    --ag-border-color: #c8c8c8;
    --ag-header-background-color: #f8f9fa;
    --ag-odd-row-background-color: #fcfcfc;
    --ag-border-radius: 6px;
  }
  
  .ag-theme-alpine .ag-cell {
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
  }
  
  .ag-theme-alpine .ag-header-cell {
    border-right: 1px solid #c8c8c8;
    border-bottom: 1px solid #c8c8c8;
    font-weight: 600;
  }
  
  .ag-theme-alpine .ag-floating-filter-input {
    border-radius: 4px;
  }
  
  .ag-theme-alpine .ag-floating-filter-input:focus {
    outline: none;
    border-color: #3f51b5;
    box-shadow: 0 0 0 2px rgba(63, 81, 181, 0.2);
  }
  
  .ag-theme-alpine .ag-header-cell::after {
    display: none;
  }
  
  .ag-theme-alpine .ag-ltr .ag-cell-first-right-pinned {
    border-left: 1px solid #c8c8c8;
  }
  
  .ag-floating-filter-button{
    margin-left: 0px !important 
  }
  
  .ag-header-cell{
    padding-left: 2px;
    padding-right: 0px;
  }
  
  .truncated-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  
  .status-chip {
    height: 20px;
    font-size: 0.75rem;
    font-weight: 600;
  }
  
   .ag-input-wrapper:before {
    background-color: white;
    display:none
  }
    .ag-theme-alpine .ag-floating-filter input[type="date"]{
      padding-left: 0 !important;
    }
            :where(.ag-ltr) .ag-header-cell-resize {
    right: -6px !important;

`;


const TruncatedCellRenderer = (props) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const cellRef = React.useRef(null);

  useEffect(() => {
    if (cellRef.current) {
      const isTextOverflowed =
        cellRef.current.scrollWidth > cellRef.current.clientWidth ||
        (props.value && props.value.length > 20);
      setIsOverflowed(isTextOverflowed);
    }
  }, [props.value]);

  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

  return (
    <Tooltip
      title={isOverflowed ? cellValue : ''}
      placement="top"
      arrow
      disableHoverListener={!isOverflowed}
    >
      <div
        ref={cellRef}
        className="truncated-cell"
        style={{ width: '100%' }}
      >
        {cellValue}
      </div>
    </Tooltip>
  );
};

const StatusCellRenderer = (props) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Paid':
        return '#4caf50';
      case 'Unpaid':
        return '#f44336';
      case 'Partial Paid':
        return '#ff9800';
      default:
        return '#757575';
    }
  };

  return (
    <Chip
      label={props.value}
      className="status-chip"
      sx={{
        backgroundColor: getStatusColor(props.value),
        color: 'white',
        width: '100%',
        maxWidth: '100px',
      }}
    />
  );
};

const BookStatusCellRenderer = (props) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Checked In': return '#635bff';
      case 'Acc Gen': return '#ff9800';
      case 'Booked': return '#2196f3';
      case 'Canceled': return '#f44336';
      case 'Availble': return '#4caf50';
      case 'Checked Out': return '#FF7043';
      case 'Booking Confirmed': return '#42bff5';
      default: return '#999';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'C': return 'Acc Gen';
      case 'P': return 'Pending';
      case 'W': return 'Waitlisted';
      case 'X': return 'Cancelled';
      case 'B': return 'Booked';
      case 'L': return 'Checked Out';
      case 'O': return 'Checked In';
      default: return status || 'Unknown';
    }
  };

  return (
    <Chip
      label={getStatusLabel(props.value)}
      className="status-chip"
      sx={{
        backgroundColor: getStatusColor(props.value),
        color: 'white',
        width: '100%',
        maxWidth: '100px',
        fontWeight: 'bold'
      }}
    />
  );
};

const CheckboxCellRenderer = (props) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (props.node.isSelected()) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [props.node]);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    props.node.setSelected(event.target.checked);
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      disabled={props.data && props.context?.isRowSelectable ? !props.context?.isRowSelectable(props.data) : false}
    />
  );
};

// Main Component

const AdviceGenerateTablePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const contentRef = useRef(null);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [pendingData, setPendingData] = useState([]);
  const [openBillingModal, setOpenBillingModal] = useState(false);
  const [billingDetails, setBillingDetails] = useState(null);
  const [planDataState, setPlanDataState] = useState(null);
  const [payAdvice, setPayAdvice] = useState(null);
  const [payGenerate, setPayGenerate] = useState(null);
  const [pendingDetails, setPendingDetails] = useState(null);
  const [summaryReport, setSummaryReport] = useState(null);
  const [receiptSummary, setReceiptSummary] = useState(null);
  const [isPendingLoading, setIsPendingLoading] = useState(false);
  const baseUrl = window.location.origin;
  const [paymentStatus, setPaymentStatus] = useState('All');
  const [sendEmailAfterGenerate, setSendEmailAfterGenerate] = useState(true);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  });
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewDetailsData, setViewDetailsData] = useState(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [pendingGridApi, setPendingGridApi] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedPendingRows, setSelectedPendingRows] = useState([]);
  const UserId = sessionStorage.getItem("UserId");
  const Permissions = usePermissions("Receipt Voucher");
  const Advicepermissions = usePermissions("Payment Advice");
  console.log('Advicepermissions',Advicepermissions)
  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const globalProperty = useSelector(selectGlobalProperty);
  const gatewayType = useSelector(selectGatewayType);
  const localProperty = useSelector(state => selectLocalProperty(state, 'adviceGenerate'));
  const selectedProperty = localProperty || globalProperty;
  const [actionTooltip, setActionTooltip] = useState({
    open: false,
    rowData: null,
    anchorEl: null
  });
  const [copyLinkModal, setCopyLinkModal] = useState({
    open: false,
    paymentUrl: '',
    rowData: null
  });
  const [updateRemarkModal, setUpdateRemarkModal] = useState({
    open: false,
    rowData: null,
    remark: '',
    isLoading: false
  });

  const handleUpdateRemark = (rowData) => {
    setUpdateRemarkModal({
      open: true,
      rowData: rowData,
      remark: rowData.Remark2 || '',
      isLoading: false
    });
  };

  console.log('properties:', properties);

  const handleUpdateRemarkSubmit = async () => {
    if (!updateRemarkModal.remark.trim()) {
      toast.warning("Please enter a remark");
      return;
    }

    setUpdateRemarkModal(prev => ({ ...prev, isLoading: true }));

    try {
      const userId = parseInt(sessionStorage.getItem('UserId'));
      const payload = {
        "PytAdvId": updateRemarkModal.rowData.PytAdvId,
        "PytAdvNo": updateRemarkModal.rowData.PytAdvNo,
        "Remark2": updateRemarkModal.remark.trim(),
        "UpdatedBy": userId
      };

      const response = await axiosInstance.post(
        `TrnBooking/UpdateTrnPytAdvRmk`,
        payload
      );

      if (response.data && response.data.Status === 0) {
        toast.success(response.data.Message || "Remark updated successfully");

        // Update the local state
        const updatedData = data.map(item =>
          item.PytAdvId === updateRemarkModal.rowData.PytAdvId
            ? { ...item, Remark2: updateRemarkModal.remark.trim() }
            : item
        );
        setData(updatedData);

        setUpdateRemarkModal({
          open: false,
          rowData: null,
          remark: '',
          isLoading: false
        });
      } else {
        toast.error(response.data?.Message || "Failed to update remark");
      }
    } catch (error) {
      console.error("Error updating remark:", error);
      toast.error("Failed to update remark");
    } finally {
      setUpdateRemarkModal(prev => ({ ...prev, isLoading: false }));
    }
  };
  const CustomLoadingOverlay = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          background: 'rgba(255, 255, 255, 0.8)',
          gap: 1
        }}
      >
        <CircularProgress size={40} sx={{ color: '#635bff' }} />
        <Typography variant="body2" sx={{ color: '#635bff' }}>
          Loading...
        </Typography>
      </Box>
    );
  };


  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        toast.success("Payment link copied to clipboard!");
        return true;
      }

      else {
        const textArea = document.createElement('textarea');
        textArea.value = text;

        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        textArea.style.opacity = '0';
        textArea.style.pointerEvents = 'none';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          toast.success("Payment link copied to clipboard!");
          return true;
        } else {
          throw new Error('execCommand copy failed');
        }
      }
    } catch (err) {
      console.error('Failed to copy: ', err);

      toast.warning(
        <div>
          <p>Could not auto-copy. Please manually copy:</p>
          <input
            type="text"
            value={text}
            readOnly
            style={{
              width: '100%',
              padding: '5px',
              marginTop: '5px',
              border: '1px solid #ccc',
              borderRadius: '3px'
            }}
            onClick={(e) => e.target.select()}
          />
        </div>,
        { duration: 10000 }
      );
      return false;
    }
  };
  const handleCopyPaymentLink = async (rowData) => {
    try {
      if (rowData?.IsEmail !== 'Y') {
        toast.warning("Email not sent yet. Cannot copy payment link.");
        return;
      }
      setIsLoadingDetails(true);

      const response = await axiosInstance.post(
        `PaymentGatewayLog/GetPaymentRequestLogDashBoard`,
        {
          pagenumber: 1,
          PageSize: 1,
          SearchText: rowData.PytAdvId.toString(),
          PropId: selectedProperty || 0,
          SearchFrom: moment().startOf('year').format('YYYY-MM-DD'),
          SearchTo: moment().endOf('year').format('YYYY-MM-DD'),
          Flag: "Url"
        }
      );

      if (response.data && response.data.Status === 0) {
        if (response.data.Data && response.data.Data.length > 0) {
          const paymentData = response.data.Data[0];
          const paymentUrl = paymentData.longUrl || paymentData.longurl || paymentData.url;

          if (paymentUrl) {
            // Show the URL in popup instead of auto-copying
            setCopyLinkModal({
              open: true,
              paymentUrl: paymentUrl,
              rowData: rowData
            });
          } else {
            toast.warning("No valid payment link found in response");
            console.log("Payment data:", paymentData);
          }

        } else {
          toast.warning("No payment history found for this advice");
        }
      } else {
        toast.error(response.data?.Message || "Failed to fetch payment link");
      }

    } catch (error) {
      console.error('Error fetching payment link:', error);

      if (error.response) {
        toast.error(error.response.data?.Message || "Server error occurred");
      } else {
        toast.error("Network error. Please try again.");
      }
    } finally {
      setIsLoadingDetails(false);
    }
  };

  const handleCopyFromModal = async () => {
    const success = await copyToClipboard(copyLinkModal.paymentUrl);
    if (success) {
      setCopyLinkModal({ open: false, paymentUrl: '', rowData: null });
    }
  };

  const DateCellRenderer = (props) => {
    const formatDate = (dateString) => {
      if (!dateString || dateString === "1900-01-01T00:00:00" || dateString === "0001-01-01T00:00:00") return '';

      if (dateString.includes('T')) {
        const datePart = dateString.split('T')[0];
        return moment(datePart).format('DD/MM/YYYY');
      }

      else if (dateString.includes('-')) {
        return dateString.replace(/-/g, '/');
      }
      else {
        return dateString;
      }
    };

    return (
      <div className="truncated-cell" style={{ width: '100%' }}>
        {formatDate(props.value)}
      </div>
    );
  };

  const PendingDateCellRenderer = (props) => {
    const formatDate = (dateString) => {
      if (!dateString || dateString === "1900-01-01T00:00:00" || dateString === "0001-01-01T00:00:00") return '';

      if (dateString.includes('T')) {
        const datePart = dateString.split('T')[0];
        const date = new Date(datePart);
        return moment(date).format('DD/MM/YYYY');
      }

      else if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return moment(dateString, 'YYYY-MM-DD').format('DD/MM/YYYY');
      }
      else {
        return dateString;
      }
    };

    return (
      <div className="truncated-cell" style={{ width: '100%' }}>
        {formatDate(props.value)}
      </div>
    );
  };

  const EmailStatusCellRenderer = (props) => {
    const getStatus = (value) => {
      if (value === 'Y' || value === 'Yes' || value === true) return 'Yes';
      if (value === 'N' || value === 'No' || value === false) return 'No';
      return value || 'No';
    };

    const getStatusColor = (value) => {
      if (value === 'Y' || value === 'Yes' || value === true) return '#4caf50';
      return '#f44336';
    };

    return (
      <Chip
        label={getStatus(props.value)}
        className="status-chip"
        sx={{
          backgroundColor: getStatusColor(props.value),
          color: 'white',
          width: '100%',
          maxWidth: '60px',
          fontWeight: 'bold'
        }}
      />
    );
  };


  const columnDefs = useMemo(() => [
    {
      headerName: '',
      field: 'select',
      width: 35,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      // cellRenderer: CheckboxCellRenderer,
      cellRendererParams: {
        isRowSelectable: (data) => data?.PaymentSt !== 'Paid' && data.BookStatus !== 'Canceled'
      },
      filter: false,
      sortable: false,
      resizable: false
    },
    { headerName: 'Sr.No', field: 'RowNum', width: 50, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'AdvNo', field: 'PytAdvNo', width: 90, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    {
      headerName: 'Date',
      field: 'PytAdvDt',
      width: 100,
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          // Convert cell value to date for comparison
          const dateParts = cellValue.split('/');
          if (dateParts.length === 3) {
            const day = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10) - 1;
            const year = parseInt(dateParts[2], 10);
            const cellDate = new Date(year, month, day);

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          }
          return 0;
        }
      },
      cellRenderer: DateCellRenderer
    },
    { headerName: 'Book No', field: 'BookNo', width: 90, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Property', field: 'PropName', width: 200, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Unit', field: 'RoomBedName', width: 80, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Resident', field: 'ResidentName', width: 170, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Mobile', field: 'MobileNo', width: 100, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    {
      headerName: 'Status',
      field: 'PaymentSt',
      width: 100,
      filter: 'agTextColumnFilter',
      cellRenderer: StatusCellRenderer,
      cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' }
    },
    {
      headerName: 'BookSt',
      field: 'BookStatus',
      width: 100,
      filter: 'agTextColumnFilter',
      cellRenderer: BookStatusCellRenderer,
      cellStyle: { display: 'flex', justifyContent: 'center', alignItems: 'center' }
    },
    {
      headerName: 'AdvFor',
      field: 'PytAdvFor',
      width: 210,
      filter: 'agTextColumnFilter',
      valueGetter: (params) => {
        const advFor = params.data?.PytAdvFor || '';
        const narration = params.data?.BookRemark || '';
          return advFor
      ? `${narration} (${advFor})`
      : narration;
  },
      cellRenderer: TruncatedCellRenderer
    },
    { headerName: 'Adv Amt', field: 'Amount', width: 90, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Rcd Amt', field: 'RcdAmt', width: 90, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'BalAmt', field: 'BalAmount', width: 90, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    {
      headerName: 'Due Date',
      field: 'DueDt',
      width: 100,
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          if (!cellValue || cellValue === "1900-01-01T00:00:00") return 0;

          const dateParts = cellValue.split('/');
          if (dateParts.length === 3) {
            const day = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10) - 1;
            const year = parseInt(dateParts[2], 10);
            const cellDate = new Date(year, month, day);

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          }
          return 0;
        }
      },
      cellRenderer: DateCellRenderer
    },
    { headerName: 'Due Days', field: 'DueDays', width: 90, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },

    { headerName: 'Naration', field: 'BookRemark', width: 150, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Remark', field: 'Remark', width: 150, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    {
      headerName: 'Email_St',
      field: 'IsEmail',
      width: 70,
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'equals', 'notEqual'],
        textMatcher: ({ value, filterText }) => {
          const statusMap = {
            'Y': 'Yes',
            'N': 'No',
            'Yes': 'Yes',
            'No': 'No'
          };

          const displayValue = statusMap[value] || value;
          const searchText = filterText.toLowerCase();
          if (searchText === 'y' || searchText === 'ye' || searchText === 'yes') {
            return displayValue.toLowerCase() === 'yes';
          } else if (searchText === 'n' || searchText === 'no') {
            return displayValue.toLowerCase() === 'no';
          } else {
            return displayValue.toLowerCase().includes(searchText);
          }
        },
        textFormatter: (value) => {
          const statusMap = {
            'Y': 'Yes',
            'N': 'No',
            'Yes': 'Yes',
            'No': 'No'
          };
          return statusMap[value] || value;
        }
      },
      cellRenderer: EmailStatusCellRenderer
    },
    {
      headerName: 'Email Dt',
      field: 'IsEmailDt',
      width: 100,
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          // Handle empty or default dates
          if (!cellValue || cellValue === "1900-01-01T00:00:00") return 0;

          const dateParts = cellValue.split('/');
          if (dateParts.length === 3) {
            const day = parseInt(dateParts[0], 10);
            const month = parseInt(dateParts[1], 10) - 1;
            const year = parseInt(dateParts[2], 10);
            const cellDate = new Date(year, month, day);

            if (cellDate < filterLocalDateAtMidnight) {
              return -1;
            } else if (cellDate > filterLocalDateAtMidnight) {
              return 1;
            } else {
              return 0;
            }
          }
          return 0;
        }
      },
      cellRenderer: DateCellRenderer
    },
    { headerName: 'Email', field: 'Email', width: 210, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Spl Note', field: 'Remark2', width: 220, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
  ], []);

  const pendingColumnDefs = useMemo(() => [
    {
      headerName: '',
      field: 'select',
      width: 40,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      filter: false,
      sortable: false,
      resizable: false
    },
    { headerName: 'Booking No', field: 'BookNo', width: 100, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Property', field: 'PropName', width: 190, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'MobileNo', field: 'MobileNo', width: 120, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Unit', field: 'RoombedName', width: 90, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Resident', field: 'ResidentName', width: 150, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Adv Amt', field: 'Amount', width: 90, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Bal Amt', field: 'BalAmount', width: 90, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Due Days', field: 'DueDays', width: 70, filter: 'agNumberColumnFilter', cellRenderer: TruncatedCellRenderer },
    {
      headerName: 'Due Date',
      field: 'DueDt',
      width: 100,
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          if (!cellValue) return 0;

          // Format the cell value for comparison
          let cellDate;
          if (cellValue.includes('T')) {
            const datePart = cellValue.split('T')[0];
            cellDate = new Date(datePart);
          } else {
            // Handle DD/MM/YYYY format
            const dateParts = cellValue.split('/');
            if (dateParts.length === 3) {
              const day = parseInt(dateParts[0], 10);
              const month = parseInt(dateParts[1], 10) - 1;
              const year = parseInt(dateParts[2], 10);
              cellDate = new Date(year, month, day);
            } else {
              return 0;
            }
          }

          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          } else if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          } else {
            return 0;
          }
        }
      },
      cellRenderer: PendingDateCellRenderer // Use the new renderer
    },
    { headerName: 'Remark', field: 'Remark', width: 120, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
    { headerName: 'Email', field: 'Email', width: 200, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
  ], []);

  const defaultColDef = useMemo(() => ({
    sortable: true,
    filter: true,
    resizable: true,
    floatingFilter: true,
    filterParams: {
      suppressAndOrCondition: true,
    },
    cellStyle: {
      borderRight: '1px solid #e0e0e0',
      display: 'flex',
      alignItems: 'center'
    },
    headerClass: 'ag-header-cell',
    suppressSizeToFit: true,
  }), []);

  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = gridStyles;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  useEffect(() => {
    if (properties.length === 0) {
      dispatch(fetchProperties());
    }
    fetchData();
  }, [dispatch, properties.length, selectedProperty, paymentStatus]);

  const handlePropertyChange = (event) => {
    const selectedId = event.target.value;
    const selectedProp = properties.find(p => p.Id === parseInt(selectedId));
    dispatch(setLocalProperty({
      componentId: 'adviceGenerate',
      propertyId: selectedId
    }));
    dispatch(setGlobalProperty(selectedId));
    if (selectedProp && selectedProp.GateWay_Type) {
    sessionStorage.setItem('gatewayType', selectedProp.GateWay_Type);
  }
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };


  const RowActionTooltip = ({ rowData, open, anchorEl, onClose, onViewDetails, isLoadingDetails }) => {
    const [showConfirm, setShowConfirm] = React.useState(false);

    const handleViewDetailsClick = () => {
      onViewDetails(rowData);
      onClose();
    };

    const handleSendEmail = () => {
      sendEmailForSingleRow(rowData);
      onClose();
    };

    const debugRowData = (rowData) => {

    };


    const handleAccountView = () => {
      debugRowData(rowData);
      handleBillingDetails(rowData);
      onClose();
    };

    const handleDeleteClick = () => {
      setShowConfirm(true);
    };

    const confirmDelete = () => {
      deleteSingleRow(rowData);
      setShowConfirm(false);
      onClose();
    };

    // Check if delete should be disabled
    const isDeleteDisabled = rowData?.PaymentSt === 'Paid' || rowData?.PaymentSt === 'Partial Paid';

    return (
      <>
        <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{
            sx: {
              position: 'absolute',
              margin: 0,
              top: anchorEl?.getBoundingClientRect().top - 50,
              left: anchorEl?.getBoundingClientRect().left,
            }
          }}
          BackdropProps={{ style: { backgroundColor: 'transparent' } }}
        >
          <Box sx={{ display: 'flex', p: 0.5, bgcolor: 'background.paper', borderRadius: 1 }}>
            <Tooltip title="Open Advice Form" arrow>
              <IconButton
                size="small"
                onClick={() => {
                  const url = `/adviceform`;
                  const state = { PytAdvId: rowData.PytAdvId, mode: 'view' };
                  //  const state = { PytAdvId: rowData.PytAdvId,rowdata:rowData, mode: 'view' };
                  window.open(`${window.location.origin}${url}?state=${encodeURIComponent(JSON.stringify(state))}`, '_blank');
                  onClose();
                }}
                sx={{ color: '#635bff' }}
              >
                <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="View Details" arrow>
              <IconButton
                size="small"
                onClick={handleViewDetailsClick}
                sx={{ color: '#635bff' }}
                disabled={isLoadingDetails}
              >
                {isLoadingDetails ? <CircularProgress size={16} /> : <VisibilityIcon fontSize="small" />}
              </IconButton>
            </Tooltip>

            <Tooltip title="Account View" arrow>
              <IconButton
                size="small"
                onClick={handleAccountView}
                sx={{ color: '#635bff' }}
              >
                <AccountCircleIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Send Email" arrow>
              <IconButton
                size="small"
                onClick={handleSendEmail}
                sx={{ color: '#635bff' }}
              >
                <EmailIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Special Notes" arrow>
              <IconButton
                size="small"
                onClick={() => handleUpdateRemark(rowData)}
                sx={{ color: '#635bff' }}
              >
                <BrowserUpdatedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={rowData?.IsEmail === 'Y' ? "Copy Payment Link" : "Email not sent yet"} arrow>
              <IconButton
                size="small"
                onClick={() => handleCopyPaymentLink(rowData)}
                sx={{
                  color: rowData?.IsEmail === 'Y' ? '#635bff' : '#ccc'
                }}
                disabled={rowData?.IsEmail !== 'Y'}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title={Advicepermissions.DeleteRec !== "1" ? "You don't have permission" :'Delete'} arrow>
              <span>
              <IconButton
                size="small"
                onClick={handleDeleteClick}
                sx={{ color: isDeleteDisabled ? '#ccc' : '#f44336' }}
                disabled={isDeleteDisabled || Advicepermissions.DeleteRec !=="1"}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Dialog>

        {/* Yes/No Confirmation Dialog */}
        <Dialog
          open={showConfirm}
          onClose={() => setShowConfirm(false)}
        >
          <DialogTitle sx={{ backgroundColor: '#635bff', color: '#fff' }}>
            Confirm Delete
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this payment advice? This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={confirmDelete}
              variant="contained"
              sx={{ backgroundColor: '#635bff', color: '#fff' }}
            >
              Yes
            </Button>
            <Button
              onClick={() => setShowConfirm(false)}
              variant="outlined"
              sx={{ borderColor: '#635bff', color: '#635bff' }}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const handleViewDetails = async (rowData) => {
    setIsLoadingDetails(true);
    try {
      const today = new Date().toISOString().split('T')[0];
      const payload = {
        "BookDtFrom": today,
        "BookUpToDt": today,
        "PropId": rowData.PropId?.toString() || "0",
        "Flag": "PyAdvRecVchr",
        "Id": rowData.PytAdvId
      };

      const response = await axiosInstance.post(
        `BookingReports/GetBookingReportsDetail`,
        payload
      );
      if (response.data && response.data.Status === 0 && response.data.Data) {
        setViewDetailsData(response.data.Data);
        setViewModalOpen(true);
      } else {
        toast.error("No details found for this payment advice");
      }
    } catch (error) {
      toast.error("Failed to fetch details");


    } finally {
      setIsLoadingDetails(false);
    }
  };

  const handleCloseViewModal = () => {
    setViewModalOpen(false);
    setViewDetailsData(null);
  };



 const sendEmailForSingleRow = async (rowData) => {
  setIsLoading(true);
  try {
    const userId = parseInt(sessionStorage.getItem('UserId'));
    const baseUrl = window.location.origin;

    const bookingReportsPayload = {
      BookDtFrom: "2025-02-21",
      BookUpToDt: "2025-05-09",
      PropId: rowData.PropId?.toString() || "1",
      ResidentId: "",
      RoomTypeId: "",
      RoomViewId: "",
      BookSt: rowData.PytAdvId?.toString() || "",
      Flag: "PyAdvPyMonthWise",
      Id: 0
    };
    
    const bookingReportsResponse = await axiosInstance.post(
      `BookingReports/GetBookingReportsDetail`,
      bookingReportsPayload
    );

    let monthNames = "";
    if (bookingReportsResponse.data.Status === 0 &&
      bookingReportsResponse.data.Data &&
      bookingReportsResponse.data.Data.length > 0) {
      monthNames = bookingReportsResponse.data.Data[0].Strwhere || "";
    }

    let paymentResponse = null;
    const propertyData = properties.find(p => p.Id === rowData.PropId);
    const rowGatewayType = propertyData?.GateWay_Type || gatewayType;

  
    if (rowGatewayType === 'CashFree') {
      const paymentDetails = {
        customer_details: {
          customer_email: rowData.Email || "",
          customer_name: rowData.ResidentName,
          customer_phone: rowData.MobileNo || ""
        },
        link_amount: parseFloat(rowData.BalAmount) || 0,
        link_auto_reminders: true,
        link_currency: "INR",
        link_expiry_time: "2026-06-09T15:04:05+05:30",
        link_id: `Testing9062026`,
        PropId: rowData.PropId,
        link_meta: {
          notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
          return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
          upi_intent: false
        },
        link_minimum_partial_amount: parseFloat(rowData.BalAmount) || 0,
        link_notes: {
          key_1: "CashFreepay",
          key_2: "linkCashfree"
        },
        link_notify: {
          send_email: true,
          send_sms: true
        },
        link_partial_payments: true,
        link_purpose: `${rowData.BookRemark} # ${rowData.PytAdvNo}`,
        ResidentId: rowData.ResidentId,
        Flag: "Active",
        Remark: "Testing",
        TrjType: "TrnPytAdv",
        TrjDocNo: rowData.PytAdvNo,
        TrjDocId: rowData.PytAdvId,
        cf_payment_id: "",
        payment_status: ""
      };

      const response = await axiosInstanceForPG.post(
        `PaymentGatewayLog/CreateCashFreeLink`,
        paymentDetails,
      );
      if(response.data.Status == 1) {
          return toast.error(response.data.Message);
        }
      
      if (response.data.Status == 0) {
        return toast.success(response.data.Message);
      }

      paymentResponse = response.data;
      if (typeof paymentResponse === 'string') {
        paymentResponse = JSON.parse(paymentResponse);
      }

    } else if (rowGatewayType === 'Instamojo') {
      const paymentDetails = {
        purpose: `${rowData.BookRemark} # ${rowData.PytAdvNo}`,
        amount: rowData.BalAmount,
        buyer_name: rowData.ResidentName,
        email: rowData.Email || "",
        phone: rowData.MobileNo || "",
        redirect_url: `${baseUrl}/payment-success`,
        redirecturl: `${baseUrl}/payment-success/`,
        webhook_url: '',
        ResidentId: rowData.ResidentId,
        TrjDocId: rowData.PytAdvId,
        TrjType: "TrnPytAdv",
        TrjDocNo: rowData.PytAdvNo,
        PropId: rowData.PropId || selectedProperty || 0,
      };

      const response = await axiosInstanceForPG.post(
        `Payment/CreatePaymentOrder`,
        paymentDetails,
      );
      if(response.data.Status == 1) {
          return toast.error(response.data.Message);
        }

      if (response.data.Status === 0) {
        return toast.success(response.data.Message);
      }

      paymentResponse = JSON.parse(response.data);

    } else {
      toast.error(`Unsupported gateway type: ${rowGatewayType}`);
      return;
    }


    const pdfBase64 = await generatePaymentAdvicePDF({
      rowData: rowData,
      pytAdvNo: rowData.PytAdvNo,
      pytAdvDt: rowData.PytAdvDt,
      propName: rowData.PropName,
      residentName: rowData.ResidentName,
      mobileNo: rowData.MobileNo,
      email: rowData.Email,
      bookNo: rowData.BookNo,
      balAmount: rowData.BalAmount,
      dueDt: rowData.DueDt,
      monthNames: monthNames,
      paymentUrl: rowGatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl,
      logo: logo
    });

   
    let paymentLogPayload;
    if (rowGatewayType === 'CashFree') {
      paymentLogPayload = {
        id: paymentResponse.link_id,
        cf_link_id: paymentResponse.cf_link_id,
        phone: paymentResponse.customer_details.customer_phone,
        email: paymentResponse.customer_details.customer_email,
        buyer_name: paymentResponse.customer_details.customer_name || 'null',
        amount: paymentResponse.link_amount,
        purpose: paymentResponse.link_purpose,
        expires_at: null,
        status: paymentResponse.link_status,
        send_sms: paymentResponse.link_notify.send_sms,
        send_email: paymentResponse.link_notify.send_email,
        sms_status: 'null',
        email_status: 'null',
        shorturl: 'null',
        longurl: paymentResponse.link_url,
        redirect_url: paymentResponse.link_meta.return_url,
        webhook: 'null',
        allow_repeated_payments: true,
        created_at: paymentResponse.link_created_at,
        modified_at: paymentResponse.link_created_at,
        link_qrcode: paymentResponse.link_qrcode,
        ResidentId: rowData.ResidentId,
        TrjDocNo: rowData.PytAdvNo,
        TrjDocId: rowData.PytAdvId,
        TrjType: "TrnPytAdv",
        Flag: "Active",
        Remark: "Testing",
        Gatewaytype: "CashFree",
      };
    } else {
      paymentLogPayload = {
        id: paymentResponse.payment_request.id,
        phone: paymentResponse.payment_request.phone,
        email: paymentResponse.payment_request.email,
        buyer_name: paymentResponse.payment_request.buyer_name,
        amount: paymentResponse.payment_request.amount,
        purpose: paymentResponse.payment_request.purpose,
        expires_at: paymentResponse.payment_request.expires_at,
        status: paymentResponse.payment_request.status,
        send_sms: paymentResponse.payment_request.send_sms,
        send_email: paymentResponse.payment_request.send_email,
        sms_status: paymentResponse.payment_request.sms_status,
        email_status: paymentResponse.payment_request.email_status,
        shorturl: paymentResponse.payment_request.shorturl,
        longurl: paymentResponse.payment_request.longurl,
        redirect_url: paymentResponse.payment_request.redirect_url,
        webhook: paymentResponse.payment_request.webhook,
        allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
        created_at: paymentResponse.payment_request.created_at,
        modified_at: paymentResponse.payment_request.modified_at,
        ResidentId: rowData.ResidentId,
        TrjDocNo: rowData.PytAdvNo,
        TrjDocId: rowData.PytAdvId,
        TrjType: "TrnPytAdv",
        Flag: "Active",
        Remark: "Testing",
        Gatewaytype: "Instamojo",
      };
    }

    await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

  
    const paymentToken = rowGatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
    const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;

    const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${rowData.PytAdvNo}]`;
    const Body = `Hey <strong>${rowData.ResidentName}</strong>,<br><br>
      We would like to inform you that payment advice has been created for you tenancy at <strong>${rowData.PropName}</strong>. Please find attached your payment advice with this email.<br><br>
      Following are the details : <br><br>
      Advice No: <strong>${rowData.PytAdvNo}</strong><br>
      Amount: <strong>${rowData.BalAmount}</strong><br>
      Date Of Issue: <strong>${(rowData.PytAdvDt)}</strong><br>
      Due Date: <strong>${(rowData.DueDt)}</strong><br>
      ${monthNames ? `Tenure: <strong>${monthNames.split(') , ')[0] + ')' || '-'}</strong><br>` : ''}
      ${monthNames ? `Rent of Months: <strong>${monthNames.split(') , ')[1] || '-'}</strong><br>` : ''}
      <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
      We hope you are having a pleasant stay with us. Do let us know if you need any assistance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
      Cheers,<br>
      Team Clanbridge`;

    const emailRequest = {
      ToEmail: rowData.Email ? [rowData.Email] : [],
      Subject,
      Body,
      PropId: rowData.PropId,
      UserId: userId,
      ImgFolderNm: rowData.PytAdvNo || "PytAdvice",
      DocAttachments: [
        {
          FileName: `Payment_Advice_${rowData.PytAdvNo}.pdf`,
          FileContent: `data:application/pdf;base64,${pdfBase64}`,
        },
      ],
      TblName: "TrnPytAdv",
      Id: rowData.PytAdvId,
    };

    const emailResponse = await axiosInstance.post(
      `EmailRequest/SendEmail`,
      emailRequest,
    );

    if (emailResponse.data.Status === 0) {
      toast.success(`Payment Link Sent Successfully for ${rowData.PytAdvNo}`);
    } else {
      toast.info(emailResponse.data.Message);
    }

    await fetchData();
    const updatedData = data.map(item =>
      item.PytAdvId === rowData.PytAdvId
        ? { ...item, IsEmail: 'Y', IsEmailDt: moment().format('DD/MM/YYYY') }
        : item
    );
    setData(updatedData);

  } catch (error) {
    toast.error("Failed to send Link Please enter a valid amount");
    console.error("Error in sendEmailForSingleRow:", error);
  } finally {
    setIsLoading(false);
  }
};

  const deleteSingleRow = async (rowData) => {
    setIsLoading(true);
    try {
      const payload = {
        "PytAdvId": rowData.PytAdvId,
        "BookId": rowData.BookId,
        "Flag": ""
      };

      const response = await axiosInstance.post(`TrnBooking/DeleteTrnPytAdv`, payload);

      if (response.data && response.data.Status === 0) {
        toast.success(response.data.Message || `Payment advice ${rowData.PytAdvNo} deleted successfully`);
        fetchData();
      } else {
        toast.error(response.data?.Message || `Failed to delete payment advice ${rowData.PytAdvNo}`);
      }
    } catch (error) {
      toast.error("Failed to connect to server");
    } finally {
      setIsLoading(false);
    }
  };



  const onSelectionChanged = useCallback(() => {
    if (gridApi) {
      const selectedNodes = gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data);
      setSelectedRows(selectedData);
    }
  }, [gridApi]);


  const onPendingSelectionChanged = useCallback(() => {
    if (pendingGridApi) {
      const selectedNodes = pendingGridApi.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data);
      setSelectedPendingRows(selectedData);
    }
  }, [pendingGridApi]);

  const onPendingGridReady = (params) => {
    setPendingGridApi(params.api);
  };

  const fetchData = async () => {
    setIsLoading(true);
    const apiFlag = paymentStatus === 'All' ? 'Dash' : paymentStatus;
    try {
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: "2025-02-26",
        Flag: apiFlag,
        PropId: selectedProperty || 0
      });

      if (response.data) {
        let formattedData = [];
        if (Array.isArray(response.data)) {
          formattedData = response.data;
        } else if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
          formattedData = response.data.Data;
        }

        // Fetch payment gateway logs for each advice
        const dataWithPaymentLinks = await Promise.all(
          formattedData.map(async (advice) => {
            // const paymentLog = await fetchPaymentGatewayLogs(advice.PytAdvId);

            return {
              ...advice,
              PytAdvDt: advice.PytAdvDt ? moment(advice.PytAdvDt).format('DD/MM/YYYY') : '',
              DueDt: advice.DueDt ? moment(advice.DueDt).format('DD/MM/YYYY') : '',
              IsEmailDt: advice.IsEmailDt ? moment(advice.IsEmailDt).format('DD/MM/YYYY') : '',
              DueDays: advice.DueDays ?? '0',
              PytAdvFor: advice.PytAdvFor === 'D' ? 'Deposit' :
                advice.PytAdvFor === 'R' ? 'Rent' :
                  advice.PytAdvFor === 'O' ? 'Other' :
                    advice.PytAdvFor === 'T' ? 'TopUp' : '',
              IsEmail: advice.IsEmail || advice.IsEmail || 'N',
              // longUrl: paymentLog?.longUrl || '',
              // CreatedDate: paymentLog?.CreatedDate || ''
            };
          })
        );

        setData(dataWithPaymentLinks);

        if (gridApi) {
          setTimeout(() => {
            gridApi.sizeColumnsToFit();
          }, 0);
        }
      } else {
        console.error('Error fetching payment advice data:', response.data?.Message);
      }
    } catch (error) {
      console.error('Error fetching payment advice data:', error);
    } finally {
      setIsLoading(false);
    }
  };


  const fetchPendingAdviceData = async (dateFilter = null) => {
    setIsPendingLoading(true);
    const currentDate = dateFilter || new Date();
    const formattedDate = currentDate.toISOString().split('T')[0]; // Only date part

    try {
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": formattedDate,
        "Flag": '',
        PropId: selectedProperty || 0
      });

      if (response.data && Array.isArray(response.data)) {
        const formattedData = response.data.map(item => ({
          ...item,
          DueDt: item.DueDt ? formatDateForDisplay(item.DueDt) : '',
          PytAdvDt: item.PytAdvDt ? formatDateForDisplay(item.PytAdvDt) : ''
        }));
        setPendingData(formattedData);
      } else if (response.data && response.data.Status === 0) {
        const formattedData = (response.data.Data || []).map(item => ({
          ...item,
          DueDt: item.DueDt ? formatDateForDisplay(item.DueDt) : '',
          PytAdvDt: item.PytAdvDt ? formatDateForDisplay(item.PytAdvDt) : ''
        }));
        setPendingData(formattedData);
      } else {
        toast.error(response.data?.Message || "Failed to load pending advice data");
      }
    } catch (error) {
      toast.error("Failed to connect to server");
    } finally {
      setIsPendingLoading(false);
    }
  };


  const formatDateForDisplay = (dateString) => {
    if (!dateString || dateString === "1900-01-01T00:00:00" || dateString === "0001-01-01T00:00:00") return '';

    if (dateString.includes('T')) {
      const datePart = dateString.split('T')[0];
      return moment(datePart).format('DD/MM/YYYY');
    }
    return dateString;
  };

  const handleRowClicked = (params) => {
    if (params.column?.colId === 'select') return;

    setActionTooltip({
      open: true,
      rowData: params.data,
      anchorEl: params.event.target
    });
  };

  const handleGetPendingData = () => {
    if (!selectedDate) {
      toast.warning("Please select a date first");
      return;
    }
    fetchPendingAdviceData(new Date(selectedDate));
  };

  const generatePaymentAdvice = async () => {
    const selectedNodes = pendingGridApi.getSelectedNodes();
    if (selectedNodes.length === 0) {
      toast.warning("Please select at least one row");
      return;
    }

    setIsPendingLoading(true);
    try {
      const userId = parseInt(sessionStorage.getItem('UserId'));
      const selectedRowsData = selectedNodes.map(node => node.data);

      const formatDate = (dateString) => {
        if (!dateString || dateString === "0001-01-01T00:00:00" || dateString === "1900-01-01T00:00:00") {
          // Return current date if date is invalid
          const now = new Date();
          return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} 00:00:00.000`;
        }

        try {
          let date;
          if (dateString.includes('T')) {
            date = new Date(dateString);
          } else if (dateString.includes('/')) {
            const parts = dateString.split('/');
            date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
          } else {
            date = new Date();
          }
          if (isNaN(date.getTime())) {
            throw new Error('Invalid date');
          }

          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} 00:00:00.000`;
        } catch (error) {
          console.warn('Date formatting error, using current date:', error);
          const now = new Date();
          return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} 00:00:00.000`;
        }
      };

      const selectedAdviceData = selectedRowsData.map((row, index) => {
        return {
          "DBFLAG": "I",
          "PytAdvId": row.PytAdvId || 0,
          "PytAdvNo": row.PytAdvNo || 0,
          "PytAdvDt": formatDate(row.PytAdvDt),
          "PytAdvFor": row.PytAdvFor || "R",
          "BookId": row.BookId || 0,
          "ResidentId": row.ResidentId || 0,
          "PropId": row.PropId || selectedProperty || 0,
          "Amount": row.Amount || 0,
          "BalAmount": row.BalAmount || 0,
          "Remark": row.Remark || "Generated from web",
          "BookPytAdvNo": row.BookPytAdvNo || 0,
          "RecId": index + 1,
          "RecdtlId": index + 1,
          "OthChrgId": 1,
          "RecDt": formatDate(row.RecDt),
          "RcdAmt": row.RcdAmt || 0,
          "DueAmt": row.DueAmt || 0,
          "DueDt": formatDate(row.DueDt),
          "Status": "1",
          "CreatedBy": userId
        };
      });

      const payloadObj = {
        "TrnPytAdvList": selectedAdviceData
      };

      let payloadString = JSON.stringify(payloadObj);
      payloadString = payloadString.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
      payloadString = `"${payloadString}"`;

      const response = await axiosInstance.post(
        `TrnBooking/ManageTrnPytAdv`,
        payloadString,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.data && response.data.Status === 0) {
        const generatedData = extractGeneratedIds(response.data.Data);
        if (sendEmailAfterGenerate && generatedData.length > 0) {
          await sendEmailsForGeneratedAdvice(selectedRowsData, generatedData);

          const updatedData = data.map(item => {
            const generatedRow = selectedRowsData.find(row =>
              row.BookId === item.BookId && row.ResidentId === item.ResidentId
            );
            if (generatedRow) {
              return { ...item, IsEmail: 'Y', IsEmailDt: moment().format('DD/MM/YYYY') };
            }
            return item;
          });
          setData(updatedData);
        }

        setOpenModal(false);
        fetchData();
        fetchPendingAdviceData();

        toast.success(`Successfully generated ${generatedData.length} payment advice(s)`);
      } else {
        toast.error(response.data?.Message || "Failed to generate payment advice");
      }
    } catch (error) {
      console.error("Error generating payment advice:", error); // Debug log
      if (error.response) {
        toast.error(error.response.data?.Message || "Failed to connect to server");
      } else {
        toast.error("Failed to connect to server");
      }
    } finally {
      setIsPendingLoading(false);
    }
  };

  const extractGeneratedIds = (dataString) => {
    if (!dataString) return [];

    try {

      const extractedData = [];

      const entries = dataString.split('\r\n');

      entries.forEach(entry => {
        if (entry.trim()) {

          const bookingIdMatch = entry.match(/Booking Id is:\s*(\d+)/i);
          const bookNoMatch = entry.match(/Booking No is:\s*(BK\d+)/i);
          const pytAdvIdMatch = entry.match(/Pvtadv Id is:\s*(\d+)/i);
          const pytAdvNoMatch = entry.match(/Pvtadv No is:\s*(PY\d+)/i);

          if (pytAdvIdMatch && pytAdvNoMatch) {
            extractedData.push({
              bookingId: bookingIdMatch ? parseInt(bookingIdMatch[1]) : 0,
              bookNo: bookNoMatch ? bookNoMatch[1] : '',
              pytAdvId: parseInt(pytAdvIdMatch[1]),
              pytAdvNo: pytAdvNoMatch[1]
            });
          }
        }
      });

      console.log("Extracted Data for all entries:", extractedData);
      return extractedData;
    } catch (error) {
      console.error('Error extracting generated IDs:', error);
      return [];
    }
  };



const sendEmailsForGeneratedAdvice = async (selectedRowsData, generatedData) => {
  try {
    const userId = parseInt(sessionStorage.getItem('UserId'));
    
    let successCount = 0;
    let errorCount = 0;

    for (let i = 0; i < selectedRowsData.length; i++) {
      const row = selectedRowsData[i];
      let generatedItem = generatedData[i] || null;
      

      if (!generatedItem && row.BookId) {
        generatedItem = generatedData.find(item => item.bookingId === row.BookId) || null;
      }

      if (!row.Email) {
        console.warn(`No email found for ${row.ResidentName}`);
        errorCount++;
        continue;
      }

      if (!generatedItem) {
        console.warn(`No generated advice data found for ${row.ResidentName}`);
        errorCount++;
        continue;
      }

      const pytAdvId = generatedItem.pytAdvId || generatedItem.PytAdvId || 0;
      const pytAdvNo = generatedItem.pytAdvNo || generatedItem.PytAdvNo || '';
      
      console.log('Generated Item Data:', {
        pytAdvId,
        pytAdvNo,
        fullItem: generatedItem
      });

      if (!pytAdvId || !pytAdvNo) {
        console.error(`Invalid generated data for ${row.ResidentName}:`, generatedItem);
        errorCount++;
        continue;
      }

      try {
        const bookingReportsPayload = {
          BookDtFrom: "2025-02-21",
          BookUpToDt: "2025-05-09",
          PropId: "1",
          ResidentId: "",
          RoomTypeId: "",
          RoomViewId: "",
          BookSt: pytAdvId.toString(),
          Flag: "PyAdvPyMonthWise",
          Id: 0
        };
        
        const bookingReportsResponse = await axiosInstance.post(
          `BookingReports/GetBookingReportsDetail`,
          bookingReportsPayload
        );

        let monthNames = "";
        if (bookingReportsResponse.data.Status === 0 &&
          bookingReportsResponse.data.Data &&
          bookingReportsResponse.data.Data.length > 0) {
          monthNames = bookingReportsResponse.data.Data[0].Strwhere || "";
        }

        let paymentResponse = null;
        const propertyData = properties.find(p => p.Id === row.PropId);
        const rowGatewayType = propertyData?.GateWay_Type || gatewayType;
        if (rowGatewayType === 'CashFree') {
          const paymentDetails = {
            customer_details: {
              customer_email: row.Email || "",
              customer_name: row.ResidentName,
              customer_phone: row.MobileNo || ""
            },
            link_amount: parseFloat(row.BalAmount) || 0,
            link_auto_reminders: true,
            link_currency: "INR",
            link_expiry_time: "2026-06-09T15:04:05+05:30",
            link_id: `Testing9062026`,
            PropId: row.PropId || selectedProperty || 0,
            link_meta: {
              notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
              return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
              upi_intent: false
            },
            link_minimum_partial_amount: parseFloat(row.BalAmount) || 0,
            link_notes: {
              key_1: "CashFreepay",
              key_2: "linkCashfree"
            },
            link_notify: {
              send_email: true,
              send_sms: true
            },
            link_partial_payments: true,
            link_purpose: `${row.BookRemark || row.Remark || 'Payment'} # ${pytAdvNo}`,
            ResidentId: row.ResidentId,
            Flag: "Active",
            Remark: "Testing",
            TrjType: "TrnPytAdv",
            TrjDocNo: pytAdvNo,  
            TrjDocId: pytAdvId, 
            cf_payment_id: "",
            payment_status: ""
          };

          console.log('CashFree Payment Details:', paymentDetails);

          const response = await axiosInstanceForPG.post(
            `PaymentGatewayLog/CreateCashFreeLink`,
            paymentDetails,
          );
          
          if (response.data.Status == 1) {
            toast.error(response.data.Message);
            errorCount++;
            continue;
          }
          
          if (response.data.Status == 0) {
            toast.success(response.data.Message);
            successCount++;
            continue;
          }

          paymentResponse = response.data;
          if (typeof paymentResponse === 'string') {
            paymentResponse = JSON.parse(paymentResponse);
          }

        } else if (rowGatewayType === 'Instamojo') {
          const paymentDetails = {
            purpose: `${row.BookRemark || row.Remark || 'Payment'} # ${pytAdvNo}`,
            amount: row.BalAmount,
            buyer_name: row.ResidentName,
            email: row.Email || "",
            phone: row.MobileNo || "",
            redirect_url: `${baseUrl}/payment-success`,
            redirecturl: `${baseUrl}/payment-success/`,
            webhook_url: '',
            ResidentId: row.ResidentId,
            TrjDocId: pytAdvId,  
            TrjType: "TrnPytAdv",
            TrjDocNo: pytAdvNo, 
            PropId: row.PropId || selectedProperty || 0,
          };

          console.log('Instamojo Payment Details:', paymentDetails);

          const response = await axiosInstanceForPG.post(
            `Payment/CreatePaymentOrder`,
            paymentDetails,
          );
          
          if (response.data.Status == 1) {
            toast.error(response.data.Message);
            errorCount++;
            continue;
          }

          if (response.data.Status === 0) {
            toast.success(response.data.Message);
            successCount++;
            continue;
          }

          paymentResponse = JSON.parse(response.data);

        } else {
          toast.error(`Unsupported gateway type: ${rowGatewayType}`);
          errorCount++;
          continue;
        }

        // Generate PDF
        const doc = new jsPDF();
        let yPos = 20;
        const pageWidth = doc.internal.pageSize.width;
        const margin = 20;

        if (logo) {
          const logoData = await getImageDataFromURL(logo);
          doc.addImage(logoData, 'PNG', margin, 10);
        }

        doc.setTextColor(99, 91, 255);
        doc.setFontSize(18);
        doc.text(row.PropName || "No Property Name Available", pageWidth / 2, yPos, { align: "left", fontSize: 18 });

        yPos += 10;
        doc.setFontSize(18);
        doc.setTextColor(0);
        doc.text("Payment Advice", pageWidth / 2, yPos, { align: "center" });

        doc.autoTable({
          startY: yPos + 5,
          head: [[{ content: "Payment Advice Summary", colSpan: 4, styles: { halign: "left", fillColor: [99, 91, 255], textColor: 255, fontSize: 14, cellPadding: 3 } }]],
          body: [
            [
              { content: "Advice No", styles: { fontStyle: "bold" } },
              pytAdvNo || "N/A",
              { content: "Advice Date", styles: { fontStyle: "bold" } },
              row.PytAdvDt && row.PytAdvDt !== "0001-01-01T00:00:00"
                ? moment(row.PytAdvDt, "YYYY-MM-DDTHH:mm:ss").format("DD-MM-YYYY")
                : moment().format("DD-MM-YYYY"),
            ],
            [
              { content: "Resident Name", styles: { fontStyle: "bold" } },
              row.ResidentName || "",
              { content: "Mobile No", styles: { fontStyle: "bold" } },
              row.MobileNo || "",
            ],
            [
              { content: "Email", styles: { fontStyle: "bold" } },
              row.Email || "",
              { content: "Booking No", styles: { fontStyle: "bold" } },
              row.BookNo || "",
            ],
            [
              { content: "Balance Amount", styles: { fontStyle: "bold" } },
              `${row.BalAmount || "0"}`,
            ],
            ...(monthNames ? [
              [
                { content: "Tenure", styles: { fontStyle: "bold" } },
                { content: monthNames.split(') , ')[0] + ')' || '-', colSpan: 3 }
              ],
              [
                { content: "Rent of Months", styles: { fontStyle: "bold" } },
                { content: monthNames.split(') , ')[1] || '-', colSpan: 3 }
              ]
            ] : [])
          ],
          theme: "grid",
          styles: {
            fontSize: 10,
            cellPadding: 3,
            lineColor: [229, 231, 235],
            lineWidth: 0.1,
          },
          alternateRowStyles: {
            fillColor: [249, 250, 251],
          },
          margin: { left: margin, right: margin },
        });

        yPos = doc.lastAutoTable.finalY + 15;
        doc.setFillColor(27, 41, 167);
        doc.setDrawColor(27, 41, 167);
        doc.setLineWidth(0.5);

        doc.roundedRect(pageWidth / 2 - 25, yPos, 50, 15, 3, 3, 'FD');

        doc.setTextColor(255, 255, 255);
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');

        const text = "Pay Now";
        const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const textX = (pageWidth / 2) - (textWidth / 2);
        const textY = yPos + 10;

        const paymentUrl = rowGatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl;
        doc.textWithLink(text, textX, textY, {
          url: paymentUrl,
          width: 40,
          height: 12,
          align: 'center'
        });

        yPos += 25;

        doc.setFontSize(12);
        doc.setTextColor(0);
        doc.text("Thank you for choosing Clanbridge Living Pvt Ltd", margin, yPos);
        doc.text("For any queries, please contact: support@clanbridgeliving.in", margin, yPos + 5);

        const pdfBlob = doc.output('blob');
        const pdfBase64 = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
          };
          reader.readAsDataURL(pdfBlob);
        });

        let paymentLogPayload;
        if (rowGatewayType === 'CashFree') {
          paymentLogPayload = {
            id: paymentResponse.link_id,
            cf_link_id: paymentResponse.cf_link_id,
            phone: paymentResponse.customer_details.customer_phone,
            email: paymentResponse.customer_details.customer_email,
            buyer_name: paymentResponse.customer_details.customer_name || 'null',
            amount: paymentResponse.link_amount,
            purpose: paymentResponse.link_purpose,
            expires_at: null,
            status: paymentResponse.link_status,
            send_sms: paymentResponse.link_notify.send_sms,
            send_email: paymentResponse.link_notify.send_email,
            sms_status: 'null',
            email_status: 'null',
            shorturl: 'null',
            longurl: paymentResponse.link_url,
            redirect_url: paymentResponse.link_meta.return_url,
            webhook: 'null',
            allow_repeated_payments: true,
            created_at: paymentResponse.link_created_at,
            modified_at: paymentResponse.link_created_at,
            link_qrcode: paymentResponse.link_qrcode,
            ResidentId: row.ResidentId,
            TrjDocNo: pytAdvNo,  
            TrjDocId: pytAdvId, 
            TrjType: "TrnPytAdv",
            Flag: "Active",
            Remark: `Payment Link for Payment Advice ${pytAdvNo}`,
            Gatewaytype: "CashFree",
          };
        } else {
          paymentLogPayload = {
            id: paymentResponse.payment_request.id,
            phone: paymentResponse.payment_request.phone,
            email: paymentResponse.payment_request.email,
            buyer_name: paymentResponse.payment_request.buyer_name,
            amount: paymentResponse.payment_request.amount,
            purpose: paymentResponse.payment_request.purpose,
            expires_at: paymentResponse.payment_request.expires_at,
            status: paymentResponse.payment_request.status,
            send_sms: paymentResponse.payment_request.send_sms,
            send_email: paymentResponse.payment_request.send_email,
            sms_status: paymentResponse.payment_request.sms_status,
            email_status: paymentResponse.payment_request.email_status,
            shorturl: paymentResponse.payment_request.shorturl,
            longurl: paymentResponse.payment_request.longurl,
            redirect_url: paymentResponse.payment_request.redirect_url,
            webhook: paymentResponse.payment_request.webhook,
            allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
            created_at: paymentResponse.payment_request.created_at,
            modified_at: paymentResponse.payment_request.modified_at,
            ResidentId: row.ResidentId,
            TrjDocNo: pytAdvNo, 
            TrjDocId: pytAdvId,  
            TrjType: "TrnPytAdv",
            Flag: "Active",
            Remark: `Payment Link for Payment Advice ${pytAdvNo}`,
            Gatewaytype: "Instamojo",
          };
        }

        console.log('Payment Log Payload:', paymentLogPayload);

        await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

        const paymentToken = rowGatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
        const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;
        
        const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${pytAdvNo}]`;
        const Body = `Hey <strong>${row.ResidentName}</strong>,<br><br>
          We would like to inform you that payment advice has been created for your tenancy at <strong>${row.PropName}</strong>. Please find attached your payment advice with this email.<br><br>
          Following are the details : <br><br>
          Payment Advice No: <strong>${pytAdvNo}</strong><br>
          Amount: <strong>₹${row.BalAmount}</strong><br>
          Generated Date: <strong>${moment().format('DD-MM-YYYY')}</strong><br>
          Due Date: <strong>${row.DueDt}</strong><br>
          ${monthNames ? `Tenure: <strong>${monthNames.split(') , ')[0] + ')' || '-'}</strong><br>` : ''}
          ${monthNames ? `Rent Of Months: <strong>${monthNames.split(') , ')[1] || '-'}</strong><br>` : ''}
          <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
          We hope you are having a pleasant stay with us. Do let us know if you need any assistance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
          Cheers,<br>
          Team Clanbridge`;

        const emailRequest = {
          ToEmail: [row.Email],
          Subject,
          Body,
          PropId: row.PropId,
          UserId: userId,
          ImgFolderNm: pytAdvNo || "PytAdvice",
          DocAttachments: [
            {
              FileName: `Payment_Advice_${pytAdvNo}.pdf`,
              FileContent: `data:application/pdf;base64,${pdfBase64}`,
            },
          ],
          TblName: "TrnPytAdv",
          Id: pytAdvId || 0
        };

        const emailResponse = await axiosInstance.post(
          `EmailRequest/SendEmail`,
          emailRequest,
        );

        if (emailResponse.data.Status === 0) {
          console.log(`Email sent successfully for ${pytAdvNo}`);
          toast.success(`Email sent successfully for ${pytAdvNo}`);
          successCount++;
        } else {
          console.warn(`Email failed for ${pytAdvNo}:`, emailResponse.data.Message);
          toast.warn(`Email failed for ${pytAdvNo}`);
          errorCount++;
        }

        await new Promise(resolve => setTimeout(resolve, 1000));

      } catch (error) {
        console.error(`Error sending email for ${row.ResidentName}:`, error);
        errorCount++;
      }
    }

    if (successCount > 0) {
      toast.success(`Successfully sent ${successCount} email(s)!`);
    }
    if (errorCount > 0) {
      toast.warning(`Failed to send ${errorCount} email(s).`);
    }

  } catch (error) {
    console.error("Error in sendEmailsForGeneratedAdvice:", error);
    toast.error("Error sending emails");
  }
};

  // const handleRowDoubleClick = useCallback((params) => {
  //   const url = `/adviceform`;
  //   const state = { PytAdvId: params.data.PytAdvId, mode: 'view' };

  //   window.open(`${window.location.origin}${url}?state=${encodeURIComponent(JSON.stringify(state))}`, '_blank');

  // }, [navigate]);

  const handleAdd = () => {
    navigate('/adviceform');
  }

  const handleRecipt = () => {
    const selectedNodes = gridApi.getSelectedNodes();

    if (selectedNodes.length === 0) {
      // Redirect to receipt table in new tab if no rows are selected
      window.open(`${window.location.origin}/receipt-table`, '_blank');
      return;
    }

    const selectedRowsData = selectedNodes.map(node => node.data);
    console.log(selectedRowsData, 'selectedRowsData')
    const selectedResidentIds = selectedRowsData.map(row => row.ResidentId);

    sessionStorage.setItem('receiptData', JSON.stringify({
      residentIds: selectedResidentIds,
      selectedRows: selectedRowsData
    }));

    const receiptUrl = window.location.origin + '/receipt';
    window.open(receiptUrl, '_blank');
  }

  const handleDeleteAdvice = () => {
    const selectedNodes = gridApi.getSelectedNodes();
    if (selectedNodes.length === 0) {
      toast.warning("Please select at least one row");
      return;
    }
    setOpenDeleteConfirmation(true);
  };

  const confirmDeleteAdvice = async () => {
    setIsLoading(true);
    try {
      const selectedNodes = gridApi.getSelectedNodes();
      const selectedRows = selectedNodes.map(node => node.data);

      for (const row of selectedRows) {
        const payload = {
          "PytAdvId": row.PytAdvId,
          "BookId": row.BookId,
          "Flag": ""
        };

        const response = await axiosInstance.post(`TrnBooking/DeleteTrnPytAdv`, payload);

        if (response.data && response.data.Status === 0) {
          toast.success(response.data.Message || `Payment advice ${row.PytAdvNo} deleted successfully`);
        } else {
          toast.error(response.data?.Message || `Failed to delete payment advice ${row.PytAdvNo}`);
        }
      }

      await fetchData();
      gridApi.deselectAll();
    } catch (error) {
      toast.error("Failed to connect to server");
    } finally {
      setIsLoading(false);
      setOpenDeleteConfirmation(false);
    }
  };
  


 const handleSendPaymentLink = async () => {
  const selectedNodes = gridApi.getSelectedNodes();
  if (selectedNodes.length === 0) {
    toast.warning("Please select at least one row");
    return;
  }
  setIsLoading(true);

  try {
    const userId = parseInt(sessionStorage.getItem('UserId'));
    const selectedRows = selectedNodes.map(node => node.data);

    for (const row of selectedRows) {
      const bookingReportsPayload = {
        BookDtFrom: "2025-02-21",
        BookUpToDt: "2025-05-09",
        PropId: row.PropId?.toString() || "1",
        ResidentId: "",
        RoomTypeId: "",
        RoomViewId: "",
        BookSt: row.PytAdvId?.toString() || "",
        Flag: "PyAdvPyMonthWise",
        Id: 0
      };

      const bookingReportsResponse = await axiosInstance.post(
        `BookingReports/GetBookingReportsDetail`,
        bookingReportsPayload
      );

      let monthNames = "";
      if (bookingReportsResponse.data.Status === 0 &&
        bookingReportsResponse.data.Data &&
        bookingReportsResponse.data.Data.length > 0) {
        monthNames = bookingReportsResponse.data.Data[0].Strwhere || "";
      }

      let paymentResponse = null;

   const propertyData = properties.find(p => p.Id === row.PropId);
      const rowGatewayType = propertyData?.GateWay_Type || gatewayType;
      if (gatewayType === 'CashFree') {
        const paymentDetails = {
          customer_details: {
            customer_email: row.Email || "",
            customer_name: row.ResidentName,
            customer_phone: row.MobileNo || ""
          },
          link_amount: parseFloat(row.BalAmount) || 0,
          link_auto_reminders: true,
          link_currency: "INR",
          link_expiry_time: "2026-06-09T15:04:05+05:30",
          link_id: `Testing9062026`,
          PropId: row.PropId || selectedProperty || 0,
          link_meta: {
            notify_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
            return_url: `${process.env.REACT_APP_API_URL}CashFreepayment-success/`,
            upi_intent: false
          },
          link_minimum_partial_amount: parseFloat(row.BalAmount) || 0,
          link_notes: {
            key_1: "CashFreepay",
            key_2: "linkCashfree"
          },
          link_notify: {
            send_email: true,
            send_sms: true
          },
          link_partial_payments: true,
          link_purpose: `${row.BookRemark || "Booking Advance"}, # ${row.PytAdvNo}`,
          ResidentId: row.ResidentId,
          Flag: "Active",
          Remark: "Testing",
          TrjType: "TrnPytAdv",
          TrjDocNo: row.PytAdvNo,
          TrjDocId: row.PytAdvId,
          cf_payment_id: "",
          payment_status: ""
        };

        const response = await axiosInstanceForPG.post(
          `PaymentGatewayLog/CreateCashFreeLink`,
          paymentDetails,
        );

        if(response.data.Status == 1) {
          return toast.error(response.data.Message);
        }
        
        if (response.data.Status == 0) {
          return toast.success(response.data.Message);
        }

        paymentResponse = response.data;
        if (typeof paymentResponse === 'string') {
          paymentResponse = JSON.parse(paymentResponse);
        }

        if (!paymentResponse || !paymentResponse.link_url) {
          console.error("Invalid payment response:", paymentResponse);
          toast.error("Failed to create payment link");
          continue;
        }

      } else if (gatewayType === 'Instamojo') {
       
        const paymentDetails = {
          purpose: `${row.BookRemark || "Booking Advance"}, # ${row.PytAdvNo}`,
          amount: row.BalAmount,
          buyer_name: row.ResidentName,
          email: row.Email || "",
          phone: row.MobileNo || "",
          redirect_url: `${baseUrl}/payment-success`,
          redirecturl: `${baseUrl}/payment-success/`,
          webhook_url: '',
          ResidentId: row.ResidentId,
          TrjDocId: row.PytAdvId,
          TrjType: "TrnPytAdv",
          TrjDocNo: row.PytAdvNo,
          PropId: row.PropId || selectedProperty || 0,
        };

        const response = await axiosInstanceForPG.post(
          `Payment/CreatePaymentOrder`,
          paymentDetails,
        );
        if(response.data.Status == 1) {
          return toast.error(response.data.Message);
        }

        if (response.data.Status === 0) {
          return toast.success(response.data.Message);
        }

        paymentResponse = JSON.parse(response.data);

        if (!paymentResponse || !paymentResponse.payment_request || !paymentResponse.payment_request.longurl) {
          console.error("Invalid payment response:", paymentResponse);
          toast.error("Failed to create payment link");
          continue;
        }

      } else {
        toast.error(`Unsupported gateway type: ${gatewayType}`);
        continue;
      }

      
      const pdfBase64 = await generatePaymentAdvicePDF({
        rowData: row,
        pytAdvNo: row.PytAdvNo,
        pytAdvDt: row.PytAdvDt,
        propName: row.PropName,
        residentName: row.ResidentName,
        mobileNo: row.MobileNo,
        email: row.Email,
        bookNo: row.BookNo,
        balAmount: row.BalAmount,
        dueDt: row.DueDt,
        monthNames: monthNames,
        paymentUrl: gatewayType === 'CashFree' ? paymentResponse.link_url : paymentResponse.payment_request.longurl,
        logo: logo
      });

   
      let paymentLogPayload;
      if (gatewayType === 'CashFree') {
        paymentLogPayload = {
          id: paymentResponse.link_id,
          cf_link_id: paymentResponse.cf_link_id,
          phone: paymentResponse.customer_details.customer_phone,
          email: paymentResponse.customer_details.customer_email,
          buyer_name: paymentResponse.customer_details.customer_name || 'null',
          amount: paymentResponse.link_amount,
          purpose: paymentResponse.link_purpose,
          expires_at: null,
          status: paymentResponse.link_status,
          send_sms: paymentResponse.link_notify.send_sms,
          send_email: paymentResponse.link_notify.send_email,
          sms_status: 'null',
          email_status: 'null',
          shorturl: 'null',
          longurl: paymentResponse.link_url,
          redirect_url: paymentResponse.link_meta.return_url,
          webhook: 'null',
          allow_repeated_payments: true,
          created_at: paymentResponse.link_created_at,
          modified_at: paymentResponse.link_created_at,
          link_qrcode: paymentResponse.link_qrcode,
          ResidentId: row.ResidentId,
          TrjDocNo: row.PytAdvNo,
          TrjDocId: row.PytAdvId,
          TrjType: "TrnPytAdv",
          Flag: "Active",
          Remark: "Testing",
          Gatewaytype: "CashFree",
        };
      } else {
        paymentLogPayload = {
          id: paymentResponse.payment_request.id,
          phone: paymentResponse.payment_request.phone,
          email: paymentResponse.payment_request.email,
          buyer_name: paymentResponse.payment_request.buyer_name,
          amount: paymentResponse.payment_request.amount,
          purpose: paymentResponse.payment_request.purpose,
          expires_at: paymentResponse.payment_request.expires_at,
          status: paymentResponse.payment_request.status,
          send_sms: paymentResponse.payment_request.send_sms,
          send_email: paymentResponse.payment_request.send_email,
          sms_status: paymentResponse.payment_request.sms_status,
          email_status: paymentResponse.payment_request.email_status,
          shorturl: paymentResponse.payment_request.shorturl,
          longurl: paymentResponse.payment_request.longurl,
          redirect_url: paymentResponse.payment_request.redirect_url,
          webhook: paymentResponse.payment_request.webhook,
          allow_repeated_payments: paymentResponse.payment_request.allow_repeated_payments,
          created_at: paymentResponse.payment_request.created_at,
          modified_at: paymentResponse.payment_request.modified_at,
          ResidentId: row.ResidentId,
          TrjDocNo: row.PytAdvNo,
          TrjDocId: row.PytAdvId,
          TrjType: "TrnPytAdv",
          Flag: "Active",
          Remark: "Payment Link for Payment Advice",
          Gatewaytype: "Instamojo",
        };
      }

      await axiosInstance.post('PaymentGatewayLog/InsertPaymentRequestLog', paymentLogPayload);

     
      const paymentToken = gatewayType === 'CashFree' ? paymentResponse.link_id : paymentResponse.payment_request.id;
      const intermediatePageUrl = `${baseUrl}/paymentpage?token=${paymentToken}`;
      
      const Subject = `Clanbridge Living - Payment Request For Payment Advice No. [${row.PytAdvNo}]`;
      const Body = `Hey <strong>${row.ResidentName}</strong>,<br><br>
        We would like to inform you that payment advice has been created for you tenancy at <strong>${row.PropName}</strong>. Please find attached your payment advice with this email.<br><br>
        Following are the details : <br><br>
        Advice No: <strong>${row.PytAdvNo}</strong><br>
        Amount: <strong>${row.BalAmount}</strong><br>
        Date Of Issue: <strong>${(row.PytAdvDt)}</strong><br>
        Due Date: <strong>${(row.DueDt)}</strong><br>
        ${monthNames ? `Tenure: <strong>${monthNames.split(') , ')[0] + ')' || '-'}</strong><br>` : ''}
        ${monthNames ? `Rent of Months: <strong>${monthNames.split(') , ')[1] || '-'}</strong><br>` : ''}
        <strong>Payment Link:</strong> <a href="${intermediatePageUrl}" target="_blank" style="background-color: #1b29a7ff; color: white; padding: 4px 10px; text-decoration: none; border-radius: 4px; display: inline-block; margin-top: 5px;">Pay Now</a><br><br>
        We hope you are having a pleasant stay with us. Do let us know if you need any assistance. You may contact us at <strong>sales@clanbridge.com</strong> or reach out to Your Resident Captains.<br>
        Cheers,<br>
        Team Clanbridge`;

      const emailRequest = {
        ToEmail: row.Email ? [row.Email] : [],
        Subject,
        Body,
        PropId: row.PropId,
        UserId: userId,
        ImgFolderNm: row.PytAdvNo || "PytAdvice",
        DocAttachments: [
          {
            FileName: `Payment_Advice_${row.PytAdvNo}.pdf`,
            FileContent: `data:application/pdf;base64,${pdfBase64}`,
          },
        ],
        TblName: 'TrnPytAdv',
        Id: row.PytAdvId
      };

      const emailResponse = await axiosInstance.post(
        `EmailRequest/SendEmail`,
        emailRequest,
      );

      if (emailResponse.data.Status === 0) {
        toast.success(`Payment Link Sent Successfully for ${row.PytAdvNo}`);
        const updatedData = data.map(item =>
          item.PytAdvId === row.PytAdvId
            ? { ...item, IsEmail: 'Y', IsEmailDt: moment().format('DD/MM/YYYY') }
            : item
        );
        setData(updatedData);
      } else {
        toast.info(emailResponse.data.Message);
      }
    }
    await fetchData();

  } catch (error) {
    console.error("Error in handleSendPaymentLink:", error);
    toast.error("Failed to send payment link: " + (error.message || "Amount is zero"));
  } finally {
    setIsLoading(false);
  }
};

  async function getImageDataFromURL(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const scaleFactor = 0.6;
        const canvas = document.createElement("canvas");
        canvas.width = img.width * scaleFactor;
        canvas.height = img.height * scaleFactor;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/png"));
      };
      img.src = url;
    });
  }


  const addButtonStyles = {
    background: "#635bff",
    color: "white",
    borderRadius: "50px",
    padding: "1px 8px",
    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.3)",
    transition: "background 0.3s ease",
    maxWidth: "180px",
    flexShrink: 0,
    "&:hover": {
      background: "#524ccc"
    },
    "&:disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      color: "rgba(0, 0, 0, 0.26)"
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleHomeClick = () => {
    navigate('/dashboard');
  };

  const handleLocationclick = () => {
    navigate('/enquiry/pre-registration');
  };

  const PropertyFilterJSX = (
    <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
      <InputLabel id="property-select-label">Filter by Property</InputLabel>
      <Select
        labelId="property-select-label"
        id="property-select"
        value={selectedProperty || ''}
        onChange={handlePropertyChange}
        label="Filter by Property"
      >
        {properties.map((property) => (
          <MenuItem key={property.Id} value={property.Id}>
            {property.Name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const Filters = (
    <Box sx={{
      display: "flex", alignItems: "center", gap: 1,
      justifyContent: "flex-start"
    }}
    >
      {PropertyFilterJSX}
      <Tooltip title={Advicepermissions.AddRec !=="1" ?"You don't have permission to Add":"Add "} arrow>
        <span>
        <Button
          variant="contained"
          size="small"
          onClick={handleAdd}
          sx={addButtonStyles}
          disabled={Advicepermissions.AddRec !=="1"}
        >
          <AddIcon sx={{ mr: 0.5 }} /> New
        </Button>
        </span>
      </Tooltip>
      <Tooltip title='Check Pending Advice' arrow>
        <Button
          variant="contained"
          size="small"
          onClick={() => setOpenModal(true)}
          sx={addButtonStyles}
        >
          <PaymentIcon sx={{ mr: 0.5 }} /> Pending
        </Button>
      </Tooltip>
      <Tooltip  title={Permissions.ViewRec !== "1" ? "You don't have permission to view receipts" : "Go to Recipt"} arrow>
         <span>
        <Button
          variant="contained"
          size="small"
          onClick={handleRecipt}
          sx={addButtonStyles}
          disabled={Permissions.ViewRec!=="1"}
        >
          <AddIcon sx={{ mr: 0.5 }} /> Receipt
        </Button>
        </span>
      </Tooltip>
      <Tooltip title='Send Payment Advice Link' arrow>
        <Button
          variant="contained"
          size="small"
          onClick={handleSendPaymentLink}
          sx={addButtonStyles}
          disabled={selectedRows.length === 0}
        >
          <LinkIcon sx={{ mr: 0.5 }} /> Send Link
        </Button>
      </Tooltip>
      <Tooltip title={Advicepermissions.DeleteRec !== "1" ? "You don't have permission to delete" : "Delete The selected Advice"} arrow>
        <span>
        <Button
          variant="contained"
          size="small"
          onClick={handleDeleteAdvice}
          sx={addButtonStyles}
          disabled={selectedRows.length === 0 || Advicepermissions.DeleteRec !=="1"}
        >
          <DeleteIcon /> Delete
        </Button>
        </span>
      </Tooltip>
      <Tooltip title='Previous Page' arrow>
        <IconButton
          onClick={handleBackClick}
          sx={{
            backgroundColor: '#635bff',
            borderRadius: '50%',
            width: 30,
            height: 30,
            '&:hover': {
              backgroundColor: '#635bff',
            },
            boxShadow: 3,
          }}
        >
          <ArrowBackIcon sx={{ color: 'white' }} />
        </IconButton>
      </Tooltip>
    </Box>
  );

  const handleBillingDetails = async (rowData) => {
    if (!rowData.BookId) {
      toast.info("No transaction is visible");
      return;
    }

    try {
      setIsLoading(true);

      const response = await axiosInstance.post(
        'TrnBooking/GetReportTrnBooking',
        {
          "BookId": rowData.BookId,
          "Flag": "R"
        }
      );

      if (response.data.Status === 0 && response.data.Data) {
        setBillingDetails(response.data.Data);
        setOpenBillingModal(true);

        // Fetch additional data only if we have valid IDs
        // if (rowData.RoomPlanId) {
        await fetchPlanDataState(rowData.RoomPlanId);
        // }

        await fetchPayAdvice(rowData.BookId);
        await fetchPayGenerate(rowData.BookId);
        await fetchPendingDetails(rowData.BookId);
        await fetchSummaryReport(rowData.BookId);
        await fetchReceiptReport(rowData.BookId);
      } else {
        toast.error('No billing details found');
      }
    } catch (error) {
      console.error('Error fetching billing details:', error);
      toast.error('Error fetching billing details');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchPlanDataState = async (PlanId) => {

    if (!PlanId || PlanId === "null" || PlanId === null) {
      console.warn("Invalid RoomPlanId:", PlanId);
      return;
    }

    try {
      const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
        "RoomPlanID": PlanId,
        "Flag": "R"
      });

      if (response.data.Status === 0) {
        setPlanDataState(response.data.Data);
      }
    } catch (error) {
      console.error('Error fetching plan data:', error);
    }
  };

  const fetchPayAdvice = async (BookId) => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: currentDate,
        Flag: "BookingWise",
        BookId: BookId
      });

      if (response.data.Status === 0) {
        setPayAdvice(response.data.Data);
      }
    } catch (error) {
      console.error('Error fetching payment advice:', error);
    }
  };

  const fetchPayGenerate = async (BookId) => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: currentDate,
        Flag: "GenPytAdv",
        BookId: BookId
      });

      if (response.data.Status === 0) {
        setPayGenerate(response.data.Data);
      }
    } catch (error) {
      console.error('Error fetching pay generate data:', error);
    }
  };

  const fetchSummaryReport = async (BookId) => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: currentDate,
        Flag: "GenAccSum",
        BookId: BookId
      });

      if (response.data.Status === 0) {
        setSummaryReport(response.data.Data);
      }
    } catch (error) {
      console.error('Error fetching summary report:', error);
    }
  };

  const fetchReceiptReport = async (BookId) => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const response = await axiosInstance.post('BookingReports/GetBookingReportsDetail', {
        BookDtFrom: currentDate,
        BookUpToDt: currentDate,
        PropId: "0", // Use appropriate property ID or get from rowData
        Flag: "PyAdvWiseRecVchr",
        Id: BookId
      });

      if (response.data.Status === 0) {
        setReceiptSummary(response.data.Data);
      }
    } catch (error) {
      console.error('Error fetching receipt report:', error);
    }
  };

  const fetchPendingDetails = async (BookId) => {
    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        Flag: "UnBilledAdvPyt",
        BookId: BookId,
        PytAdvDt: currentDate
      });

      if (response.data.Status === 0) {
        setPendingDetails(response.data.Data);
      }
    } catch (error) {
      console.error('Error fetching pending details:', error);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 2, background: 'rgb(249, 249, 249)', height: '90vh' }}>
      <ToastContainer />
      <Dialog
        open={openDeleteConfirmation}
        onClose={() => setOpenDeleteConfirmation(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: '#635bff', color: '#ffffff' }}>
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this payment advice? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={confirmDeleteAdvice}
            variant="contained"
            sx={{ backgroundColor: '#635bff', color: '#ffffff' }}
            color="error"
            autoFocus
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
          <Button
            onClick={() => setOpenDeleteConfirmation(false)}
            variant="outlined"
            sx={{ borderColor: '#635bff', color: '#635bff' }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Header Section */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 0.5,
        flexWrap: 'wrap',
        rowGap: 2,
        background: 'rgb(255, 255, 255)',
        padding: '2px 6px',
        borderRadius: '5px',
        boxShadow: 'rgb(0 0 0 / 8%)'
      }}>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator="›"
          sx={{
            fontSize: { xs: "14px", sm: "16px" },
            display: "flex",
            flexDirection: { xs: "column", sm: "column", md: "row" }
          }}
        >
          <Link
            underline="hover"
            color="#635bff"
            sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
            onClick={handleHomeClick}
          >
            <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            <Box component="span">Home</Box>
          </Link>

          <Link
            underline="hover"
            color="#635bff"
            sx={{ cursor: "pointer", fontWeight: "500" }}
            onClick={handleLocationclick}
          >
            Booking(Pre-Registration)
          </Link>

          <Typography color="text.primary" sx={{ fontWeight: "500" }}> Payment Advice</Typography>
        </Breadcrumbs>

        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          rowGap: 2
        }}>
          {Filters}
        </Box>
      </Box>

      {/* Payment Status Filter */}
      <Box
        sx={{
          background: 'rgb(255, 255, 255)',
          padding: '2px 6px',
          borderRadius: '5px',
          boxShadow: 'rgb(0 0 0 / 8%)',
          mb: 0.5,
        }}
      >
        <FormControl component="fieldset" fullWidth>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            {/* Payment Status Left Side */}
            <Stack direction="row" spacing={2} alignItems="center">
              <FormLabel
                id="payment-status-label"
                sx={{ fontSize: '18px', fontWeight: 'bold' }}
              >
                Payment Status
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="payment-status-label"
                name="payment-status"
                value={paymentStatus}
                onChange={(e) => setPaymentStatus(e.target.value)}
              >
                <FormControlLabel value="All" control={<Radio />} label="All" />
                <FormControlLabel value="Paid" control={<Radio />} label="Paid" />
                <FormControlLabel value="Unpaid" control={<Radio />} label="Unpaid" />
                <FormControlLabel value="Partial" control={<Radio />} label="Partial" />
              </RadioGroup>
            </Stack>

            {/* Selected Count Right Side */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Tooltip title='Check outstanding reports' arrow>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => window.open('/outstanding', '_blank')}
                  sx={{ textTransform: 'none', padding: '0px 3px' }}
                >
                  Outstanding Report
                </Button>
              </Tooltip>

              {/* Selected Count */}
              <Box sx={{ whiteSpace: 'nowrap' }}>
                Selected Count: {selectedRows.length}
              </Box>
            </Stack>
          </Box>
        </FormControl>
      </Box>

      {/* AG Grid Table */}
      <Paper
        elevation={2}
        sx={{
          height: 'calc(100vh - 200px)',
          width: '100%',
          flexGrow: 1,
          overflow: 'hidden'
        }}
      >
        <div
          className="ag-theme-alpine"
          style={{
            height: '100%',
            width: '100%',
            overflowX: 'auto'
          }}
        >
          {isLoading ? (
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 10,
              textAlign: 'center',
            }}
            >
              <CircularProgress size='3rem' sx={{ color: '#635bff' }} />
              <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                Loading Data...
              </Typography>
            </Box>
          ) : (
            <AgGridReact
              columnDefs={columnDefs}
              rowData={data}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              onRowClicked={handleRowClicked}
              // onRowDoubleClicked={handleRowDoubleClick}
              pagination={true}
              paginationPageSize={1000}
              paginationPageSizeSelector={[15, 50, 100, 500, 1000, 5000]}
              suppressRowClickSelection={true}
              rowSelection={'multiple'}
              enableCellTextSelection={true}
              ensureDomOrder={true}
              loading={isLoading}
              rowHeight={30}
              headerHeight={30}
              floatingFiltersHeight={28}
              overlayLoadingComponent={CustomLoadingOverlay}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No data found</span>'
              }
              suppressMenuHide={true}
              enableRangeSelection={true}
              sideBar={false}
              suppressHorizontalScroll={false}
              onSelectionChanged={onSelectionChanged}
              isRowSelectable={(rowNode) => {
                const row = rowNode.data;
                return row?.PaymentSt !== 'Paid' && row.BookStatus !== 'Canceled';
              }}
              context={{
                isRowSelectable: (data) => data?.PaymentSt !== 'Paid' && data?.BookStatus !== 'Canceled'
              }}
            />
          )}
        </div>
      </Paper>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '90vh',
            minHeight: '50vh'
          }
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          background: '#dddbff',
          padding: '16px 24px',
          whiteSpace: "nowrap"
        }}>
          <Typography variant="h6" component="div" >
            Pending Payment Advice Details
          </Typography>
          <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
            <Grid item>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={sendEmailAfterGenerate}
                    onChange={(e) => setSendEmailAfterGenerate(e.target.checked)}
                    sx={{
                      color: '#635bff',
                      '&.Mui-checked': {
                        color: '#635bff',
                      },
                    }}
                  />
                }
                label="Auto Email"
                sx={{ minWidth: 120 }}
              />
            </Grid>
            <Grid item>
              <TextField
                type="date"
                label="Select Date"
                value={selectedDate || moment().format('YYYY-MM-DD')}
                onChange={(e) => setSelectedDate(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  max: moment().add(30, 'days').format('YYYY-MM-DD'),
                }}
                sx={{ minWidth: 150 }}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<GetDataIcon />}
                onClick={handleGetPendingData}
                disabled={!selectedDate || isPendingLoading}
                sx={{
                  backgroundColor: '#635bff',
                  '&:hover': {
                    backgroundColor: '#4b44c9',
                  }
                }}
              >
                Get Data
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SendIcon />}
                onClick={generatePaymentAdvice}

                disabled={selectedPendingRows.length === 0 || isPendingLoading}
                sx={{
                  backgroundColor: '#635bff',
                  '&:hover': {
                    backgroundColor: '#4b44c9',
                  }
                }}
              >
                Generate Advice
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={() => setOpenModal(false)}
                variant="outlined"
                sx={{ borderColor: '#635bff', color: '#635bff' }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers>
          {isPendingLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
              <CircularProgress />
            </Box>
          ) : pendingData.length === 0 ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
              <Typography variant="h6" color="textSecondary">
                {selectedDate ? 'No Pending Record Found for Selected Date' : 'Please select a date and click "Get Data" to view pending records'}
              </Typography>
            </Box>
          ) : (
            <div
              className="ag-theme-alpine"
              style={{
                height: '400px',
                width: '100%'
              }}
            >
              <AgGridReact
                columnDefs={pendingColumnDefs}
                rowData={pendingData}
                defaultColDef={defaultColDef}
                onGridReady={onPendingGridReady}
                pagination={true}
                paginationPageSize={100}
                paginationPageSizeSelector={[50, 100, 500]}
                suppressRowClickSelection={true}
                rowSelection={'multiple'}
                enableCellTextSelection={true}
                ensureDomOrder={true}
                loading={isPendingLoading}
                rowHeight={30}
                headerHeight={30}
                floatingFiltersHeight={28}
                overlayLoadingTemplate={
                  '<span class="ag-overlay-loading-center">Loading data...</span>'
                }
                overlayNoRowsTemplate={
                  '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No data found</span>'
                }
                suppressMenuHide={true}
                enableRangeSelection={true}
                sideBar={false}
                suppressHorizontalScroll={false}
                onSelectionChanged={onPendingSelectionChanged}
              />
            </div>
          )}

        </DialogContent>
      </Dialog>

      <Dialog
        open={viewModalOpen}
        onClose={handleCloseViewModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle sx={{
          backgroundColor: '#635bff',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          Receipt Account Details
          <IconButton onClick={handleCloseViewModal} sx={{ color: 'white' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ pt: 2, p: 0 }}>
          {viewDetailsData && viewDetailsData.length > 0 ? (
            <Box sx={{ width: '100%', overflow: 'auto' }}>
              <TableContainer sx={{ maxHeight: '60vh' }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Receipt No</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Receipt Date</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Advice No</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Amount (₹)</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Payment Of</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Mode</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>TRN No</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>TRN Date</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Created Date</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#deddefff', color: 'black' }}>Remark</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {viewDetailsData.map((item, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' },
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <TableCell>{item.RecNo || 'N/A'}</TableCell>
                        <TableCell>
                          {item.RecDt ? moment(item.RecDt).format('DD/MM/YYYY') : 'N/A'}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>{item.PytAdvNo || 'N/A'}</TableCell>

                        <TableCell sx={{ fontWeight: 'bold', color: '#635bff' }}>
                          ₹{item.Amount ? item.Amount.toLocaleString('en-IN') : '0.00'}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>{item.InstallmentNo || 'N/A'}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>{item.Flag || 'N/A'}</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>{item.ChqNo || 'N/A'}</TableCell>
                        <TableCell>
                          {item.ChqDt ? moment(item.ChqDt).format('DD/MM/YYYY') : 'N/A'}
                        </TableCell>
                        <TableCell>
                          {item.CreatedDate ? moment(item.CreatedDate).format('DD/MM/YYYY') : 'N/A'}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>{item.SearchText || 'N/A'}</TableCell>

                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ) : viewDetailsData ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <Typography>No details available</Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress />
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <RowActionTooltip
        open={actionTooltip.open}
        rowData={actionTooltip.rowData}
        anchorEl={actionTooltip.anchorEl}
        onClose={() => setActionTooltip({ open: false, rowData: null, anchorEl: null })}
        onViewDetails={handleViewDetails}
        isLoadingDetails={isLoadingDetails}
      />

      <BillingDetailsModal
        open={openBillingModal}
        onClose={() => setOpenBillingModal(false)}
        billingData={billingDetails}
        planData={planDataState}
        payAdvice={payAdvice}
        payGenerate={payGenerate}
        pendingDetails={pendingDetails}
        summaryReport={summaryReport}
        receiptSummary={receiptSummary}
      />
      <Dialog
        open={copyLinkModal.open}
        onClose={() => setCopyLinkModal({ open: false, paymentUrl: '', rowData: null })}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          backgroundColor: '#635bff',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          Payment Link
          <IconButton
            onClick={() => setCopyLinkModal({ open: false, paymentUrl: '', rowData: null })}
            sx={{ color: 'white' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 3 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Resident: {copyLinkModal.rowData?.ResidentName}
            </Typography>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Advice No: {copyLinkModal.rowData?.PytAdvNo}
            </Typography>
          </Box>

          <Typography variant="body2" color="textSecondary" gutterBottom>
            Payment Link:
          </Typography>

          <TextField
            fullWidth
            value={copyLinkModal.paymentUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  {/* <Tooltip title="Copy to clipboard">
              <IconButton onClick={handleCopyFromModal}>
                <ContentCopyIcon />
              </IconButton>
            </Tooltip> */}
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                pr: 1,
              }
            }}
          />

          {/* <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
      <Button
        variant="contained"
        onClick={handleCopyFromModal}
        startIcon={<ContentCopyIcon />}
        sx={{
          backgroundColor: '#635bff',
          '&:hover': {
            backgroundColor: '#524ccc',
          },
        }}
      >
        Copy Link
      </Button>
      
      <Button
        variant="outlined"
        onClick={() => {
          window.open(copyLinkModal.paymentUrl, '_blank');
        }}
        startIcon={<OpenInNewIcon />}
        sx={{
          borderColor: '#635bff',
          color: '#635bff',
          '&:hover': {
            borderColor: '#524ccc',
            backgroundColor: 'rgba(99, 91, 255, 0.04)',
          },
        }}
      >
        Open Link
      </Button>
    </Box> */}
        </DialogContent>
      </Dialog>

      <Dialog
        open={updateRemarkModal.open}
        onClose={() => setUpdateRemarkModal(prev => ({ ...prev, open: false }))}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{
          backgroundColor: '#635bff',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 1
        }}>
          Write Special Notes
          <IconButton
            onClick={() => setUpdateRemarkModal(prev => ({ ...prev, open: false }))}
            sx={{ color: 'white' }}
            disabled={updateRemarkModal.isLoading}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Advice No: <strong>{updateRemarkModal.rowData?.PytAdvNo}</strong>
            </Typography>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Resident: {updateRemarkModal.rowData?.ResidentName}
            </Typography>
          </Box>

          <TextField
            fullWidth
            label="Special Notes"
            value={updateRemarkModal.remark}
            onChange={(e) => setUpdateRemarkModal(prev => ({
              ...prev,
              remark: e.target.value
            }))}
            multiline
            rows={2}
            placeholder="Enter Notes here..."
            disabled={updateRemarkModal.isLoading}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => setUpdateRemarkModal(prev => ({ ...prev, open: false }))}
            variant="outlined"
            sx={{ borderColor: '#635bff', color: '#635bff' }}
            disabled={updateRemarkModal.isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUpdateRemarkSubmit}
            variant="contained"
            sx={{
              backgroundColor: '#635bff',
              '&:hover': { backgroundColor: '#524ccc' },
            }}
            disabled={updateRemarkModal.isLoading || !updateRemarkModal.remark.trim()}
            startIcon={updateRemarkModal.isLoading ? <CircularProgress size={20} /> : null}
          >
            {updateRemarkModal.isLoading ? 'Submiting...' : 'Submit'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box >

  );
};

export default AdviceGenerateTablePage;